import type { SessionApi } from "@opencode-ai/client/promise"
import { normalizeSessionInfo } from "@/utils/session"
import type { OpencodeClient } from "@opencode-ai/sdk/v2/client"

export async function loadRootSessions(input: {
  api: Pick<SessionApi, "list">
  directory: string
  limit: number
  cursor?: string
}) {
  const result = await input.api.list({
    directory: input.directory,
    parentID: null,
    limit: input.limit,
    order: "desc",
    cursor: input.cursor,
  })
  return {
    data: result.data.map(normalizeSessionInfo),
    // 下一页游标：后端在有数据时总会返回 next，由调用方按"本页是否满页"决定是否采用。
    nextCursor: result.cursor.next ?? undefined,
    limit: input.limit,
  } as const
}

export async function loadRootSessionsV1(input: { client: OpencodeClient; directory: string; limit: number }) {
  try {
    const result = await input.client.session.list({ directory: input.directory, roots: true, limit: input.limit })
    // v1 协议无游标分页，nextCursor 恒空（追加加载在 v1 下为 no-op）。
    return { data: result.data, nextCursor: undefined as string | undefined, limit: input.limit } as const
  } catch {
    const result = await input.client.session.list({ directory: input.directory, roots: true })
    return { data: result.data, nextCursor: undefined as string | undefined, limit: input.limit } as const
  }
}
